"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TruckAPI = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _helper = require("@/services/helper/helper.service");

var _request = require("@/services/request/request.service");

var TruckAPI = /*#__PURE__*/function () {
  function TruckAPI(_ref) {
    var lfToken = _ref.lfToken,
        userSetting = _ref.userSetting;
    (0, _classCallCheck2.default)(this, TruckAPI);
    this.settings = {};
    this.lfToken = null;
    this.requestAuth = null;
    this.helper = new _helper.Helper();
    this.pageSize = 500;
    this.settings = userSetting;
    this.lfToken = lfToken;
    this.requestAuth = new _request.Request('application/json', this.lfToken);
  }

  (0, _createClass2.default)(TruckAPI, [{
    key: "getTrucks",
    value: function getTrucks(store) {
      var modeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'lastmile';
      var param = {
        'modeType': modeType,
        'limit': this.pageSize,
        'order': 'plateNumber:ASC'
      };
      var filterQuery = this.helper.getFilterQuery(store['truckFilters']);

      if (!this.helper.isUndefined(filterQuery.queryAnd)) {
        param['query'] = filterQuery.queryAnd;
      }

      var hook2 = this.helper.get(this.settings, 'hook2', '');

      if (!this.helper.isUndefined(hook2)) {
        return this.requestAuth.get(hook2, '', param, true);
      }

      return this.requestAuth.get('LEGACY_CORE_V3', 'routeplanning/trucks', param);
    }
  }, {
    key: "getTrucksV2",
    value: function getTrucksV2() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var exactValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var allCompany = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var param = {
        'exactValue': exactValue || false,
        'allCompany': allCompany || false,
        'limit': this.pageSize
      };

      if (query) {
        param['query'] = query;
      }

      var hook2 = this.helper.get(this.settings, 'hook2', '');

      if (!this.helper.isUndefined(hook2)) {
        return this.requestAuth.get(hook2, '', param, true);
      }

      return this.requestAuth.get('LEGACY_CORE_V3', 'routeplanning/trucks', param);
    }
  }]);
  return TruckAPI;
}();

exports.TruckAPI = TruckAPI;